import React from 'react';
import Container from '../../Layouts/Container';

const Divider = () => (<Container><hr /></Container>);

export default Divider;
